import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { env } from '../app.constant';

@Component({
  selector: 'ngx-auth-redirect',
  templateUrl: './auth-redirect.component.html',
  styleUrls: ['./auth-redirect.component.scss']
})
export class AuthRedirectComponent {

  private actRoute: ActivatedRoute = inject(ActivatedRoute);
  private cookie: CookieService = inject(CookieService);
  private router: Router = inject(Router);

  private routing: any = {
    realignment: "signatory/realignment",
    dashboard: "dashboard",
    budget: "budget"
  };

  constructor() {
    let page = this.actRoute.snapshot.paramMap.get('page');
    let token = this.actRoute.snapshot.paramMap.get('token');
    let campus = this.actRoute.snapshot.paramMap.get('campus');

    console.log(`page ${page}`);
    console.log(`token ${token}`);
    console.log(`campus ${campus}`);

    let now = new Date();
    now.setHours(now.getHours() + env.token_hours_expiration);

    this.cookie.set('AuthToken', token, { expires: now, secure: env.secure, sameSite: 'Strict' });
    this.cookie.set('expiration', now.getTime().toString());

    this.router.navigate([`/pages/${this.routing[page]}`]);

  }
}
